import type { Intersection } from 'utility-types'

import type { CybusDetailedEndpoint, CybusEndpoint } from '../../../../../../domain'

import { mapResourceName, type Resource } from '../../../../mappers'

export const mapBaseEndpoint = ({
    resourceId,
    serviceId,
    resourceConfig: { args },
    protocol,
    runnerName,
}: Resource<'Endpoint'>): Omit<Intersection<CybusDetailedEndpoint, CybusEndpoint>, 'status'> => ({
    id: resourceId,
    name: mapResourceName(resourceId),
    service: serviceId,
    operation: args.operation,
    protocol,
    agent: runnerName || null,
})
